import * as React from "react";
import {Business, CurrentUser, LocationOffer, UserCard} from "../../types/Types";
import {useState} from "react";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, Query, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";
import DisplayListControl from "../list/DisplayListControl";
import {getActiveOffers} from "../../utils/Utils";
import OfferTicket from "./location/OfferTicket";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
  business: string | undefined,
  location: string | undefined,
  displayTitle: string | undefined,
  defaultDisplayList: boolean,
  pointsCard: UserCard | undefined,
}

function OfferList(props: Props) {
  const [offers, setOffers] = useState<Array<LocationOffer>>([]);
  const [displayList, setDisplayList] = useState<boolean>(props.defaultDisplayList);

  const activeOffers = getActiveOffers(props.pointsCard, offers);

  useEffect(() => {(async () => {
    let offers = new Array<LocationOffer>();
    let offersCollection = {} as Query;
    if(props.location) {
      offersCollection = query(
          collection(db, 'offers'),
          where("status", "==", "ACTIVE"),
          where("location", "==", props.location),
          orderBy("createdAt", "desc"),
          limit(200),
      );
    } else if(props.business) {
      offersCollection = query(
          collection(db, 'offers'),
          where("status", "==", "ACTIVE"),
          where("business", "==", props.business),
          orderBy("createdAt", "desc"),
          limit(200),
      );
    } else {
      offersCollection = query(
          collection(db, 'offers'),
          where("status", "==", "ACTIVE"),
          orderBy("createdAt", "desc"),
          limit(200),
      );
    }
    const offersSnapshot = await getDocs(offersCollection);
    offersSnapshot.forEach((doc) => {
      offers.push(doc.data() as LocationOffer);
    });
    setOffers(offers);
  })();
  }, []);

  return (
      <div className={"mt-3"}>
        {props.displayTitle && <div className={`list-title ${displayList ? "mb-3" : "mb-0"}`} onClick={() => setDisplayList(!displayList)}>
            <b>{props.displayTitle}</b>
            <DisplayListControl displayList={displayList} count={activeOffers.length} />
        </div>}
        {(displayList && offers.length > 0) && <div className={"centre-align"}>
          {activeOffers.map((offer, index) => (
              <div className={`${index == activeOffers.length-1 ? 'mb-0' : 'mb-2'} d-inline-block`}>
                <OfferTicket offer={offer} business={props.businessMap.get(offer.business)} pointsCard={props.pointsCard} showReceipt={false}/>
              </div>
          ))}
        </div>}
        {/*{(offers.length === 0 && displayList) && <div className={"basic-box colour-secondary mt-2 mb-0"}>Nothing to display.</div>}*/}
      </div>
  )
}

export default OfferList;